export function formatRupiah(n) {
  const num = Number(n || 0);
  const sign = num < 0 ? "-" : "";
  return `${sign}Rp ${Math.abs(num).toLocaleString("id-ID", { maximumFractionDigits: 0 })}`;
}

export function formatDateID(iso) {
  if (!iso) return "-";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  if (!y || !m || !d) return iso;
  return `${d}-${m}-${y}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function digitsOnly(s) {
  return String(s || "").replace(/\D/g, "");
}

export function formatNumberInput(n) {
  if (n === null || n === undefined || n === "" || Number.isNaN(Number(n))) return "";
  return Number(n).toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export function parseDigits(s) {
  const d = digitsOnly(s);
  return d ? Number(d) : 0;
}
